<template>
    <brick-square-base class="journey-brick" :class="classList">
        <journey-builder-composer-touchpoint-overview
                ref="overview"
                
                :brick-id="id"
                :brick-name="name"
                :brick-type="type"
                :brick-config="config"
                :brick-is-new="isNew"

                :incoming-connections-info="IncomingConnectionsInfo"
                :outgoing-connections-info="OutgoingConnectionsInfo"
        >
            <template>
                <div class="brick-menu">

                    <journey-brick-menu
                            :is-active="isActive"
                            :has-connections="hasConnections"
                            :brick-type="type"
                            :is-child-journey-brick="isChildJourneyBrick"

                            @info-click="showOverview()"
                            @add-connection-click="$emit('add-connection', $event)"
                            @delete-click="$emit('delete-brick', true)"
                            @settings-click="showSettings = true"
                    />
                </div>

                <div class="brick-icon">
                    <i :class="icon" />
                </div>

                <div class="brick-title">
                    <span class="center">
                        {{name}}
                    </span>
                </div>

                <component v-if="showSettings"
                           :is="editorType"

                           :value="config"
                           :name="name"
                           :show="showSettings"
                           :availableConditions="availableConditions"
                           @hide="showSettings = false"
                           @save="$emit('settings-changed', $event)"
                           @delete="$emit('delete-brick', false)"
                />

            </template>
        </journey-builder-composer-touchpoint-overview>
    </brick-square-base>
</template>

<script>
    import getBrickIcon from '../../Bricks/brick-icons';
    import snowplow from '../../snowplow';
    import brickTypes from "../../Bricks/brick-types";

    import journeyBrickMixin from '../../Mixins/journey-brick'

    import BrickSquareBase from './../BrickSquareBase.vue';
    import JourneyBrickMenu from './JourneyBrickMenu.vue';
    import JourneyBuilderComposerTouchpointOverview from './JourneyBuilderComposerTouchpointOverview.vue';

    import BrickSettingsAudience from './BrickSettings/Audience/BrickSettingsAudience.vue'
    import BrickSettingsTouchpoint from './BrickSettings/Touchpoint/TouchpointBrickSettings.vue';
    import BrickSettingsJourney from "./BrickSettings/Journey/BrickSettingsJourney.vue";
    
    const brickTypeEditorMapping = {
        [brickTypes.audience]: BrickSettingsAudience,
        [brickTypes.touchpoint]: BrickSettingsTouchpoint,
        [brickTypes.journey]: BrickSettingsJourney
    };
    
    export default {
        name: 'journey-brick-square',
        components: {
            BrickSquareBase,
            JourneyBrickMenu,
            JourneyBuilderComposerTouchpointOverview,
            BrickSettingsTouchpoint
        },
        mixins: [journeyBrickMixin],
        methods: {
            showOverview(tab){
                snowplow.trackStructuredEvent('show-brick-overview');
                
                this.$refs.overview.show(tab);
            }
        },
        computed: {
            icon(){
                return getBrickIcon(this.type, this.config);
            },
            hasConnections() {
                return this.IncomingConnectionsInfo.length !== 0 || this.OutgoingConnectionsInfo.length !== 0;
            },
            editorType(){
                return brickTypeEditorMapping[this.type];
            },
            classList() {
                const vm = this;
                
                const list = [];

                list.push(vm.config.goal === true ? 'goal' : vm.brickTypeName);
                list.push(vm.isActive ? 'active' : 'undefined');

                if(vm.isChildJourneyBrick){
                    list.push('child-journey');
                }
                
                return list;
            }
        },
        data() {
            return {
                settings: {},
                showSettings: false
            }
        },
        props: {
            id: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            isNew: {
                type: Boolean,
                required: false,
                default: false
            },
            isChildJourneyBrick: {
                type: Boolean,
                required: true
            },
            IncomingConnectionsInfo: {
                type: Array,
                required: true
            },
            OutgoingConnectionsInfo: {
                type: Array,
                required: true
            },
            availableConditions: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style scoped src="../../Style/journey-brick-square.scss" lang="scss"/>